import React, { useState, useEffect } from 'react';
import { PeekBox, PeekTextField, PeekInputAdornment, PeekContainedIconButton } from '@piiqtechnologies/ui-components';
import { Edit2, Check } from '@piiqtechnologies/svg-icons';
import { usePannellumViewer } from '../../../components/pannellum-viewer/PannellumProvider.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../../utils/ErrorProvider.js';
import { useLoader } from '../../../../utils/LoaderProvider.js';
import { useRefetch } from '../../../../utils/RefetchProvider.js';
import '../../../../utils/NotificationProvider.js';
import 'tslib';
import '../../../../utils/ContactProvider.js';
import '../../../../utils/PolicyProvider.js';
import '../../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../../types/AccessDevice.js';
import '../../../../types/Analytics.js';
import '../../../../types/CASACommunity.js';
import '../../../../types/Community.js';
import '../../../../types/DxSettings.js';
import '../../../../types/MagicButton.js';
import '../../../../types/Pannellum.js';
import '../../../../types/Prospect.js';
import '../../../../types/ProspectIntelligence.js';
import '../../../../types/Space.js';
import '../../../../types/Tour.js';
import '../../../../utils/analyticsPlugin.js';
import '../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../utils/cookieUtils.js';
import '../../../../utils/termsConditionsAgreementsUtils.js';
import { getNodeById } from '../../../components/pannellum-viewer/pannellumUtils.js';
import '../../../../services/base/baseDiscoverService.js';
import '../../../../services/base/baseV3Service.js';
import '../../../../services/base/baseInsightsService.js';
import '../../../../services/sgtService.js';
import '../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../services/base/internalApiBaseService.js';
import '../../../../services/base/casaBaseService.js';
import '../../../../services/scanRequestsService.js';
import '../../../../services/db/insightsReportsDB.js';
import '../../../../services/aiDiscoverability.js';
import 'dot-object';
import '../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useUpdateSpaceNode } from '../../../../apis/space/useUpdateSpaceNode.js';
import '../../../../apis/upload/useSignedURL.js';

const RoomName = () => {
    const { getConfig, details, setViewerContext } = usePannellumViewer();
    const [updateSpaceNode, updatedSpace, updateSpaceNodeInProgress, updateSpaceNodeError] = useUpdateSpaceNode();
    const { nodeId } = getConfig();
    const node = getNodeById(details.nodes, nodeId);
    const { setError } = useError();
    const { setLoader } = useLoader();
    const [roomName, setRoomName] = useState(node.label || null);
    const [isEditing, setIsEditing] = useState(false);
    const { setRefetch } = useRefetch();
    useEffect(() => {
        setRoomName(node.label);
    }, [node.label]);
    const toggleEditName = () => {
        setIsEditing((isEditing) => !isEditing);
        if (isEditing) {
            updateSpaceNode({
                spaceId: details._id,
                node: {
                    label: roomName,
                },
                nodeId,
            });
        }
    };
    const onChangeRoomName = (event) => {
        setRoomName(event.target.value);
    };
    useEffect(() => {
        if (updatedSpace) {
            setViewerContext({ details: updatedSpace });
            setRefetch({ sceneId: nodeId });
        }
    }, [updatedSpace]);
    useEffect(() => {
        if (updateSpaceNodeError) {
            setError(updateSpaceNodeError === null || updateSpaceNodeError === void 0 ? void 0 : updateSpaceNodeError.message);
        }
    }, [updateSpaceNodeError]);
    useEffect(() => {
        setLoader(updateSpaceNodeInProgress, "updateSpaceNode");
        return () => setLoader(false, "updateSpaceNode");
    }, [updateSpaceNodeInProgress]);
    return (React.createElement(PeekBox, null,
        React.createElement(PeekTextField, { variant: "standard", sx: { m: 0, "& .MuiInput-root": { mt: 0, boxShadow: "none" } }, value: roomName, onChange: onChangeRoomName, InputLabelProps: { required: true }, InputProps: {
                readOnly: !isEditing,
                disableUnderline: true,
                "aria-label": "Image Name",
                endAdornment: (React.createElement(PeekInputAdornment, { sx: { py: 1.35, px: 1, borderRadius: 0.5, m: 0, ml: -1 }, position: "start" },
                    React.createElement(PeekContainedIconButton, { "aria-label": "toggle edit name", onClick: toggleEditName }, (!isEditing && React.createElement(Edit2, null)) || React.createElement(Check, null)))),
            } })));
};

export { RoomName, RoomName as default };
